export default __webpack_public_path__ + "static/media/nft15.5b5706ad.png";